import { ListItemButton } from "@mui/material";
import { PropsWithChildren } from "react";
import { useLocation, useResolvedPath } from "react-router";
import LinkBehavior from "./LinkBehavior";

export function NavButton({
  href,
  indent,
  onClick,
  children,
}: PropsWithChildren<{
  href: string;
  indent?: boolean;
  onClick?: () => void;
}>) {
  const path = useResolvedPath(href);
  let location = useLocation();
  const active = location.pathname.startsWith(path.pathname);

  return (
    <ListItemButton
      component={LinkBehavior}
      href={href}
      selected={active}
      onClick={onClick}
      sx={{ pl: indent ? 9 : undefined }}
    >
      {children}
    </ListItemButton>
  );
}
